import {
  Component,
  h,
  Prop,
  getAssetPath,
  ComponentInterface,
} from '@stencil/core';
import { MyAccountUser } from './global-nav-interface';

/**
 * Nanopore digital global navigation user profile.
 */
@Component({
  tag: 'nano-global-nav-user-profile',
  assetsDirs: ['assets'],
})
export class GlobalNavUserProfile implements ComponentInterface {
  /**
   * Logged in user details automatically populated from MyAccount
   */
  @Prop() myAccountUser: MyAccountUser = null;

  /**
   * Link to the user profile
   */
  @Prop() userProfileUrl: string = '';

  // Render output

  render() {
    return (
      <a href={this.userProfileUrl} class="user-profile">
        <div class="left">
          <div class="avatar-container">
            <img
              class="avatar"
              src={this.myAccountUser.small_avatar_url}
              alt="User Avatar"
              height={75}
              width={75}
            />
            {this.myAccountUser.is_nanopore_user && (
              <img
                class="logo-small"
                src={getAssetPath(`./assets/ont-wheel-light.svg`)}
                alt="Nanopore Logo"
              />
            )}
          </div>

          <div class="user-details">
            <span class="name">{this.myAccountUser.name}</span>

            <span class="bio">
              {this.myAccountUser.job_title} at {this.myAccountUser.company}
            </span>
          </div>
        </div>

        <div class="right">
          <div class="chevron-right">
            <nano-icon
              slot="icon-end"
              name="light/chevron-right"
              aria-label="navigate to ..."
            ></nano-icon>
          </div>
        </div>
      </a>
    );
  }
}
